<style scoped lang="less">
.modal-footer {
    display: block;
    text-align: center;
}
</style>
<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">Error Occurred</h2>
            <button type="button" class="close icon icon-close" @click="$emit('close')" autofocus aria-label="Close" />
        </div>
        <div class="modal-body">
            <div v-if="content" v-html="content" describedby-text></div>
            <p describedby-text class="action-failure-text" v-else>An error occurred while submitting. Please try again later.</p>
        </div>
        <div class="modal-footer">
            <a class="btn btn-outline-secondary" tabindex="0" @click.prevent="$emit('close')">Ok</a>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
import { asyncComputed } from "@vueuse/core";
import { useMainStore } from "@/mainStore";
interface Props extends DialogProps {}
export default defineComponent({
    props: ["triggerElement"],
    setup(props: Props) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);
        const mainStore = useMainStore();
        return {
            content: asyncComputed(() => mainStore.tenantData?.customErrorHtml, null),
            container: containerRef,
        };
    },
});
</script>
